/* eslint-disable no-console -- Centralized logger intentionally uses console.* */
// Lightweight logger utility. In production builds (process.env.NODE_ENV === 'production')
// non-critical logs (debug/info) are no-ops. Warn/error always pass through.
// No side effects beyond console.* so tree-shaking can drop unused levels.

export type LogLevel = "debug" | "info" | "warn" | "error";

interface Logger {
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

const isProd = process.env.NODE_ENV === "production";

const base: Logger = {
  debug: (...args) => {
    if (!isProd) console.debug("[debug]", ...args);
  },
  info: (...args) => {
    if (!isProd) console.log("[info]", ...args);
  },
  warn: (...args) => console.warn("[warn]", ...args),
  error: (...args) => console.error("[error]", ...args),
};

export const logger: Logger = base;

export function logLevelEnabled(level: LogLevel): boolean {
  if (level === "warn" || level === "error") return true;
  return !isProd; // debug/info disabled in production
}
